import React, { useEffect, useState } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../../components/common/ShadowCard";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import { getAllPaymentAndReceipt } from "../../account/services/account.services";
import FormSelectionField from "../../../components/formFields/FormSelectionField";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const DummyChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const createdBy = localStorage.getItem("UserID");
  useEffect(() => {
    formRenderProps.onChange("UserID", {
      value: createdBy,
    });
  }, []);

  return null;
};

const CashBookReportForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const BankBookDetails = useAppSelector(
    (state) => state.reports.BankBookDetails
  );
  const AccountPaymentAndReceiptList = useAppSelector(
    (state) => state.account.AccountPaymentAndReceiptList
  );
  const [initialValue, setInitialValue] = useState<any>({});
  const [formKey, setFormKey] = useState<any>(1);

  useEffect(() => {
    const payload = {
      account_name: "",
      under_group_id: "18",
    };

    dispatch(getAllPaymentAndReceipt(payload));
  }, []);

  useEffect(() => {
    setInitialValue({
      ...BankBookDetails,
      from_date: BankBookDetails?.from_date
        ? moment(BankBookDetails?.from_date, "YYYY-MM-DD").toDate()
        : null,
      to_date: BankBookDetails?.to_date
        ? moment(BankBookDetails?.to_date, "YYYY-MM-DD").toDate()
        : null,
    });
    setFormKey(formKey + 1);
  }, [BankBookDetails]);

  const handleSubmit = (values: any) => {
    const payload = {
      ledger_id: values?.ledger_id ? values?.ledger_id?.split("--")[0] : 0,
      ledger_name: values?.ledger_id ? values?.ledger_id?.split("--")[1] : "0",
      from_date: values?.from_date
        ? moment(values?.from_date).format("YYYY-MM-DD")
        : null,
      to_date: values?.to_date
        ? moment(values?.to_date).format("YYYY-MM-DD")
        : null,
    };
    // dispatch(setBankBookDetailsReport(payload));
    // dispatch(getBankBookReport(payload));
    window.open(
      `/cashbookreport/${payload?.ledger_id}/${payload?.ledger_name}/${payload?.from_date}/${payload?.to_date}`
    );
  };

  return (
    <>
      <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <ShadowCard>
            <Form
              key={formKey}
              initialValues={initialValue}
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ width: "100%" }}>
                  <GridLayout
                    style={{ marginRight: 30 }}
                    gap={{ rows: 10, cols: 10 }}
                    cols={[
                      { width: "25%" },
                      { width: "25%" },
                      { width: "25%" },
                      { width: "25%" },
                    ]}
                  >
                    <GridLayoutItem colSpan={4}>
                      <Typography.h4
                        style={{ marginBottom: 0, marginLeft: "3px" }}
                      >
                        Cash Book
                      </Typography.h4>
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="from_date"
                        label="From Date"
                        format="dd/MM/yyyy"
                        component={FormDatePicker}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="to_date"
                        label="To Date"
                        format="dd/MM/yyyy"
                        minDate={
                          moment(
                            formRenderProps.valueGetter("from_date")
                          ).toDate() || new Date(1900, 0, 1)
                        }
                        component={FormDatePicker}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="ledger_id"
                        label="Ledger"
                        placeholder="Type here to search Ledger..."
                        component={FormSelectionField}
                        validator={requiredValidator}
                        astrike={true}
                        options={AccountPaymentAndReceiptList.map(
                          (ledger: any) => {
                            return {
                              value: `${ledger?.id}--${ledger?.account_name}`,
                              label: ledger?.account_name,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      colSpan={4}
                      style={{
                        textAlign: "end",
                        marginTop: 10,
                      }}
                    >
                      <ButtonWithLoading
                        label={"View"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                  <DummyChangeWatcher formRenderProps={formRenderProps} />
                </FormElement>
              )}
            />
          </ShadowCard>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default CashBookReportForm;
